// extracted by mini-css-extract-plugin
export default {"fleet-instrument-toggle-options":"conventional-pcr-frontend-fleet-management-styles-fleet-management-module__fleet-instrument-toggle-options--yUDaEVPGJxDpcshBCC5TlQ=="};